import { Module } from '@nestjs/common'
import { staticController } from './static.controller'

@Module({
	controllers: [staticController],
})
export class StaticModule {}
